import { ModalBlock } from '@sb1/ffe-modals-react';
import { Heading2 } from '@sb1/ffe-core-react';
import SharePostPreview from '../SharePostPreview';
import FacebookShareButton from '../FacebookShareButton';
import { trackEvent } from '../../../support-and-tracking/analytics-actions';
import TwitterShareButton from '../TwitterShareButton';
import { Icon } from '@sb1/ffe-icons-react';
import { useProject } from '../../project-hooks/useProject';
import styles from './shareOnProject.module.less';
import { IMAGE, QR, POSTER, EMBED, TVA_IMAGES } from './share-on-project-model';
import { SecondaryButton } from '@sb1/ffe-buttons-react';
import image from '@sb1/ffe-icons/icons/open/300/lg/image.svg';
import poster from '@sb1/ffe-icons/icons/open/300/lg/print.svg';
import qr from '@sb1/ffe-icons/icons/open/300/lg/qr_code.svg';
import email from '@sb1/ffe-icons/icons/open/300/lg/email.svg';
import embed from '@sb1/ffe-icons/icons/open/300/lg/code_off.svg';
import { mailShareUrl } from '../../../utils';
import { InputWithCopyButton } from '../../../components/input-with-copy/InputWithCopyButton';
import { isProjectPartOfTVA } from '../../project-model';
import { useSelector } from 'react-redux';

export const DesktopStartModalContainer = ({ setShowPage, prettyUrlToShare, trackingProperties, subprojectId }) => {
    const project = useProject();
    const campaigns = useSelector((state) => state.campaigns);

    const isTvaProject = isProjectPartOfTVA(campaigns, project);

    const trackClick = (channel) => {
        trackEvent('project', 'share-desktop-modal', {
            channel,
            ...trackingProperties,
        });
    };

    return (
        <ModalBlock>
            <Heading2 id="share-modal-title">Del spleisen</Heading2>
            <SharePostPreview projectId={project.id} subprojectId={subprojectId} className={styles.projectPreview} />
            <div className={styles.sharingButtons}>
                <FacebookShareButton
                    horizontal
                    logoAsButton={true}
                    urlToShare={prettyUrlToShare}
                    trackEventFunction={() => trackClick('facebook')}
                    buttonClassName={styles.button}
                />
                <TwitterShareButton
                    horizontal
                    logoAsButton={true}
                    urlToShare={prettyUrlToShare}
                    trackEventFunction={() => trackClick('twitter')}
                    buttonClassName={styles.button}
                />
                {project.img_url && !isTvaProject && (
                    <div className={styles.horizontalButtonGroup}>
                        <SecondaryButton
                            className={styles.button}
                            iconOnly
                            label="Bilde"
                            onClick={() => {
                                setShowPage(IMAGE);
                                trackClick('show-image-modal');
                            }}
                            aria-label={'Del bilde'}
                        >
                            <Icon fileUrl={image} size="lg" />
                        </SecondaryButton>
                        <div>Bilde</div>
                    </div>
                )}

                {isTvaProject && project.img_url && (
                    <div className={styles.horizontalButtonGroup}>
                        <SecondaryButton
                            className={styles.button}
                            iconOnly
                            label="Bilde"
                            onClick={() => {
                                setShowPage(TVA_IMAGES);
                                trackClick('show-tva-image-modal');
                            }}
                            aria-label={'Del TV-aksjonsbilde'}
                        >
                            <Icon fileUrl={image} size="lg" />
                        </SecondaryButton>
                        <div>Delingsbilder</div>
                    </div>
                )}

                <div className={styles.horizontalButtonGroup}>
                    <SecondaryButton
                        className={styles.button}
                        iconOnly
                        label="E-post"
                        onClick={() => {
                            const mailUrl = mailShareUrl(prettyUrlToShare, project.title);
                            trackClick('email');
                            location.href = mailUrl;
                        }}
                        aria-label={'Del på E-post'}
                    >
                        <Icon fileUrl={email} size="lg" />
                    </SecondaryButton>
                    <div>E-post</div>
                </div>

                {project.img_url && (
                    <div className={styles.horizontalButtonGroup}>
                        <SecondaryButton
                            className={styles.button}
                            iconOnly
                            label="Plakat"
                            onClick={() => {
                                trackClick('show-poster-modal');
                                setShowPage(POSTER);
                            }}
                            aria-label={'Del plakat'}
                        >
                            <Icon fileUrl={poster} size="lg" />
                        </SecondaryButton>
                        <div>Plakat</div>
                    </div>
                )}
                <div className={styles.horizontalButtonGroup}>
                    <SecondaryButton
                        className={styles.button}
                        iconOnly
                        label="QR-kode"
                        onClick={() => {
                            trackClick('show-qr-modal');
                            setShowPage(QR);
                        }}
                        aria-label={'Del QR-kode'}
                    >
                        <Icon fileUrl={qr} size="lg" />
                    </SecondaryButton>
                    <div>QR-kode</div>
                </div>

                <div className={styles.horizontalButtonGroup}>
                    <SecondaryButton
                        className={styles.button}
                        iconOnly
                        label="Bygg inn"
                        onClick={() => {
                            trackClick('show-embed-modal');
                            setShowPage(EMBED);
                        }}
                        aria-label={'Bygg inn på nettside'}
                    >
                        <Icon fileUrl={embed} size="lg" />
                    </SecondaryButton>
                    <div>Bygg inn</div>
                </div>
            </div>
            <div>
                <InputWithCopyButton
                    label={'Lenke til spleisen'}
                    prettyUrlToShare={prettyUrlToShare.replace('https://', '')}
                    trackEventFunction={() => trackClick('copy')}
                />
            </div>
        </ModalBlock>
    );
};
